import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { CompanyInfoResponse } from 'hooks';
import { useToast } from 'hooks/useToast';

/**
 * Interface for company info payload
 */
export interface CompanyInfoPayloadUpdate {
  name?: string;
  industry?: string;
  hiring_frequency?: string;
  no_of_employees?: string;
  company_logo?: string;
}

/**
 * Hook for updating company info using TanStack React Query
 */
export const useUpdateCompanyInfo = (
  getUser: () => void,
  setImage: (value: { show: boolean; type: string }) => void
) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: CompanyInfoPayloadUpdate) => {
      const response = await apiClient.put<CompanyInfoResponse>('/auth/company/', payload);
      return response.data;
    },
    onSuccess: (data) => {
      getUser();
      setImage({ show: false, type: '' });
      openToast({
        show: true,
        heading: data.message ?? 'Company profile updated!',
        text: '',
        type: 'success',
        timeOut: 2000,
      });
    },
    onError: (err: any) => {
      console.error('Update Company Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.error?.message ||
        err?.response?.data?.message ||
        'Failed to update your company profile, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};